export default "__VITE_ASSET__BXwOvmdc__"